import { Button } from "@/components/Button"
import { FormCountrySelect } from "@/components/Form/CoutrySelect"
import { Input } from "@/components/Form/Input"
import { ExClient, useRainCorporateFormContext, useStoreClient } from "@usher/pe-client-front-end-lib"
import { useCallback } from "react"
import { useHistory } from "react-router"

// const WEBSITE_PATTERN = /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,}(\/[^\s]*)?$/i

const CompanyInfo = () => {
  const { formMethods, submitCompanyInfo } = useRainCorporateFormContext()
  const navigate = useHistory()
  const onSubmit = useCallback(async () => {
    try {
      await submitCompanyInfo()
      const data = await ExClient.getPersonalInfo()
      // @ts-ignore
      useStoreClient.setState((state) => ({ ...state, user: { ...state.user, entity_id: data.entity_id, tax_id: data.tax_id } }))
      navigate.push("/company-verification/form/company-address")
    } catch (error) {
      console.error(error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const { control, handleSubmit } = formMethods
  return (
    <div className="">
      <h1 className="text-2xl text-black mb-4">Add Company Information</h1>
      <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <label className="mb-1">Country of Business Incorporation</label>
        <FormCountrySelect disabled name="company_info.corp_country_code" control={control} required />
        <label className="mt-2.5 mb-1">State</label>
        <Input.Form disabled name="company_info.corp_state" control={control} required />
        <label className="mt-2.5 mb-1">Business Name</label>
        <Input.Form disabled name="company_info.company_name" required control={control} />
        <div className="grid grid-cols-2 gap-2.5 mt-2.5">
          <div className="col-span-1">
            <label className="mb-1">Business Entity ID</label>
            <Input.Form name="company_info.entity_id" required control={control} />
          </div>
          <div className="col-span-1">
            <label className="mb-1">Tax ID (EIN Number)</label>
            <Input.Form name="company_info.tax_id" required control={control} />
          </div>
        </div>
        <label className="mt-2.5 mb-1">Website</label>
        <Input.Form
          disabled
          name="company_info.site"
          control={control}
          // rules={{ pattern: { value: WEBSITE_PATTERN, message: "Invalid website URL" } }}
        />
        <div className="flex justify-end mt-4">
          <Button className="w-full">Continue</Button>
        </div>
      </form>
    </div>
  )
}

export default CompanyInfo
